<template>
 <v-card class="py-2 px-8">
          <v-tabs       background-color="transparent"

          :centered="true"
>
  <v-tab>
    Oppsummering
  </v-tab>
  <v-tab>
    Referanser
  </v-tab>
  <v-tab-item>
    <v-card flat>
      <v-row>
          <v-col>
              <h1>{{title}}</h1>
          <h2 class="grey--text">{{year}}</h2>
          <div class="pt-8">
                  {{description}}
          </div>
          </v-col>
          <v-col>
              <v-chip
      class="ma-2"
      color="primary"
    >
      todo : putt inn nøkkelord
    </v-chip>
          </v-col>
      </v-row>   
    </v-card>
  </v-tab-item>
  <v-tab-item>
    <v-card flat>

  <v-row>
      <v-col cols="2">
          <v-avatar
            class="profile"
            color="grey"
            size="164"
            tile
          >
            <v-img src="https://cdn.vuetifyjs.com/images/profiles/marcus.jpg"></v-img>
          </v-avatar>
      </v-col>
      <v-col>
          <v-list-item-content>
              <v-list-item-title class="title">Kul person</v-list-item-title>
              <v-list-item-subtitle>Teamleder</v-list-item-subtitle>
            </v-list-item-content>
            <v-card class="pa-4">
                <h3>
                    <v-icon class="pr-4">fas fa-phone</v-icon>
                    {{referencePhoneNumber}}</h3>

            <h3 class="pt-4">
                <v-icon class="pr-4">fas fa-envelope</v-icon>
                {{referenceEmail}}</h3>
            </v-card>
      </v-col>
      <v-col style="margin-left:40px;">
        <p class="text-left">
              <v-icon >fas fa-quote-left</v-icon>
        </p>
          <center>
          <h2 class="grey--text">
            <slot />
          </h2>
          </center>
                  <p class="text-right">
              <v-icon >fas fa-quote-right</v-icon>
        </p>
      </v-col>
  </v-row> 
    </v-card>
  </v-tab-item>
</v-tabs>
          
      </v-card>
</template>

<script>
export default {
  props: ["title", "year", "description", "referencePhoneNumber", "referenceEmail"]

}
</script>

<style>

</style>